import { OPEN_MODAL, CLOSE_MODAL } from "../actions/types";


const initialState = {
  modalName:null,
  
}
export default (state = initialState, { type, payload }) => {


    switch (type) {
        case OPEN_MODAL:
            return { ...state,modalName: payload };
        case CLOSE_MODAL:
            return { ...state,modalName: null };
        default:
            return state;
    }
};